// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3jfWC","headline":"headline__9wDpC","mobileDeleteButton":"mobileDeleteButton__3eaHU","breadcrumbs":"breadcrumbs__1yBFU"};